// extracted by mini-css-extract-plugin
var _1 = "ApplicantDecisionPanel-modulecontent__eOQzA WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "ApplicantDecisionPanel-moduledivider__igPbD Divider-moduleDivider__dL3Vg";
var _3 = "ApplicantDecisionPanel-moduleledger__jHgJs";
export { _1 as "content", _2 as "divider", _3 as "ledger" }
